<template>

  <div class="container-fluid min-vh-100 bg-main">
    
    <div v-if="character">
    
        <div class="container pt-5 my-5">
            
            <h1 class="display-1">{{ character.name }}</h1>

            <div class="p-5 text-center rounded-3">
            
            <div class="pb-4"><img class="img-fluid" :src="character.image" :alt="character.name"></div>
            <!-- <h1 class="text-body-emphasis pb-3">{{ character.name }}</h1> -->

            <div class="col-lg-8 mx-auto fs-5 text-muted mb-4">
                | {{ character.status }} | {{ character.species }} | {{ character.gender }} | {{ character.type }}
            </div>

            <p class="col-lg-8 mx-auto fs-5 text-muted pb-1">
                <div :key="index" v-for="(origin, index) in character">
                    <div v-if="index=='origin'">

                        <!-- <a class="text-muted" :href="extractId(origin.url)">{{ origin.name }}</a> -->
                        <div v-if="origin.name=='unknown'">
                            <span class="text-dark pe-3">Origin:</span> Unknown
                        </div>

                        <router-link v-else :to="{name:'location', params:{id:extractId(origin.url)} }" class="routerlink">
                            <span class="text-dark pe-3">Origin: </span>
                            <a class="muted-text">{{origin.name}}</a>
                        </router-link>
                    </div>
                </div>
            </p>
            
            <p class="col-lg-8 mx-auto fs-5 text-muted">
                <div :key="index" v-for="(loc, index) in character" >
                    <div v-if="index=='location'">

                        <div v-if="loc.name=='unknown'">
                            <span class="text-dark pe-3">Location:</span> Unknown
                        </div>

                        <!-- <a class="text-muted" href="#">{{ loc.name }}</a> -->
                        <router-link v-else :to="{name:'location', params:{id:extractId(loc.url)} }" id="locationdiv" class="routerlink">
                            <span class="text-dark pe-3">Location:</span>
                            <a>{{loc.name}}</a>
                        </router-link>
                    </div>
                </div>
            </p>

            <div class="pt-4 pb-5">
                <button @click="alleps( character.episode )" class="btn btn-secondary">Show Episodes</button>
            </div>

            <div class="row row-cols-1 row-cols-md-4 g-4 justify-content-evenly">
                <div v-bind:key="eps" v-for="(eps) in episodes" id="episode-card">
                    <div v-if="eps">
                        <div class="card">
                            <div class="card-header">
                                {{eps.episode}}
                            </div>
                            <div class="card-body">
                                <router-link :to="{name:'episode', params:{id:eps.id}}" class="routerlink">
                                <a>{{eps.name}}</a>
                                </router-link>                            
                            </div>
                            <div class="card-footer">
                                {{eps.air_date}}
                            </div>
                        </div>
                        
                    </div>
                </div>
            </div>

            </div>
        </div>
    
    </div>
    <div v-else class="display-3">Loading...</div>

    </div>  
    
</template>

<script>
import getEpisodes from '@/composables/episodes/getEpisodes';
import { onMounted } from 'vue';
import { ref } from 'vue';

export default {

    props: ['id'],
    data() {
        return {
            character: {},
            episode:'',
            episodes:'',
            episodenames:''
        }
    },
    setup(props) {
        
        onMounted( () => console.log('Component Setup'))

        const prop = ref(props)

        const extractId = ( (url) => {
            console.log(url)
            if( url && (url !=='undefined') ) {
                var urlsplit = url.split('/')
                var newid = urlsplit[ urlsplit.length - 1 ]
                return newid
            }
        })

        return { prop, extractId }
    },
    created() {

    },
    mounted( ) {
        onMounted( () => {
            console.log( 'Component mounted' ) 
        })

        var url='';
        if( !this.prop.id || this.prop.id=='undefined') {
            var charid = Math.floor(Math.random() * 600);
            url = 'https://rickandmortyapi.com/api/character/' + charid
        } else {
            url = 'https://rickandmortyapi.com/api/character/' + this.prop.id
        }

        fetch( url )
            .then( res => res.json() )
            .then( data => this.character=data )
            .catch( error => console.log( error.message ) )
    },
    methods: {
         alleps( alleps ) {       
            const { episodes, loadeps } = getEpisodes( alleps )
            loadeps()
            this.episodes = episodes
            return { episodes }
        },
    }
}
</script>

<style scoped>
.bg-main  {
    background-color:antiquewhite;
    background-image: var(--bs-gradient);    
}
</style>